var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 309.499c0-80.013-80.373-135-165-135-6.064 0-12.112.281-18.115.816.733-5.209 1.115-10.486 1.115-15.816 0-80.013-80.373-135-165-135-86.444 0-165 56.426-165 135 0 34.456 15.581 66.7 44.105 91.734L22.537 337.5l97.327-48.663c15.852 3.806 30.669 5.662 45.136 5.662 6.102 0 12.152-.279 18.136-.81-.743 5.231-1.136 10.507-1.136 15.81 0 80.013 80.373 135 165 135 14.466 0 29.284-1.855 45.136-5.662l97.327 48.663-21.568-86.267C496.419 376.199 512 343.955 512 309.499zm-395.504-52.518-49.033 24.517 10.422-41.687C75.239 236.917 30 210.431 30 159.499c0-57.897 60.561-105 135-105s135 47.103 135 105-60.561 105-135 105c-24.201 0-45.155-6.798-48.504-7.518zm328.042 174.517-49.033-24.517c-3.744.805-24.076 7.518-48.504 7.518-74.439 0-135-47.103-135-105 0-7.16.936-14.269 2.781-21.218 44.224-11.369 85.988-39.702 104.968-81.618 8.925-1.429 18.064-2.164 27.252-2.164 74.439 0 135 47.103 135 105 0 50.59-45.159 77.33-47.884 80.312z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 144.499h30v30H90zM150 144.499h30v30h-30zM210 144.499h30v30h-30zM272 294.499h30v30h-30zM332 294.499h30v30h-30zM392 294.499h30v30h-30z",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviews);
export default __webpack_public_path__ + "static/media/interviews.ce40e8948cc5d2412019343d323d6923.svg";
export { ForwardRef as ReactComponent };